import { render, staticRenderFns } from "./PackageView.vue?vue&type=template&id=c03c16ba&scoped=true"
import script from "./PackageView.vue?vue&type=script&lang=js"
export * from "./PackageView.vue?vue&type=script&lang=js"
import style0 from "./PackageView.vue?vue&type=style&index=0&id=c03c16ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03c16ba",
  null
  
)

export default component.exports